export default ({ request }) => ({
  ecomShipmentContainerListApi(data = {}) {
    return request({
      url: '/ecom/shipment/container/list',
      method: 'POST',
      data,
      timeout: 30000,
    })
  },
  ecomShipmentContainerSaveApi(data = {}) {
    return request({
      url: '/ecom/shipment/container/save',
      method: 'POST',
      data,
      timeout: 30000,
    })
  },
  ecomShipmentContainerDelApi(data = {}) {
    return request({
      url: '/ecom/shipment/container/del',
      method: 'POST',
      data,
      timeout: 30000,
    })
  },
  ecomShipmentContainerAddGoodsApi(data = {}) {
    return request({
      url: '/ecom/shipment/container/addGoods',
      method: 'POST',
      data,
      timeout: 30000,
    })
  },
  ecomShipmentContainerChangeGoodsApi(data = {}) {
    return request({
      url: '/ecom/shipment/container/changeGoods',
      method: 'POST',
      data,
      timeout: 30000,
    })
  },
  ecomShipmentContainerRemoveGoodsApi(data = {}) {
    return request({
      url: '/ecom/shipment/container/removeGoods',
      method: 'POST',
      data,
      timeout: 30000,
    })
  },
  ecomShipmentContainerChangeSortOrderApi(data = {}) {
    return request({
      url: '/ecom/shipment/container/changeSortOrder',
      method: 'POST',
      data,
      timeout: 30000,
    })
  },
  ecomShipmentContainerSchedulingApi(data = {}) {
    return request({
      url: '/ecom/shipment/container/scheduling',
      method: 'POST',
      data,
      timeout: 30000,
    })
  },
  ecomShipmentContainerDetailApi(data = {}) {
    return request({
      url: '/ecom/shipment/container/detail',
      method: 'POST',
      data,
      timeout: 30000,
    })
  },
  ecomShipmentContainerBatchAddGoodsApi(data = {}) {
    return request({
      url: '/ecom/shipment/container/goods/batch-add',
      method: 'POST',
      data,
      timeout: 30000,
    })
  },
})
